import superUserRequest from 'utils/superUserRequest';

const fetchUsersSuperUserPaginated = async ({ page, pageSize, ordering, ...filters }) =>
  superUserRequest('GET', '/v1/super-users', null, {
    params: {
      page,
      page_size: pageSize,
      ...(ordering ? { ordering } : {}),
      ...filters,
    },
  });

const fetchImpersonationUsers = async ({ page, pageSize, search, ordering } = {}) =>
  superUserRequest('GET', '/v1/users', null, {
    params: {
      page,
      page_size: pageSize,
      ...(search ? { search } : {}),
      ...(ordering ? { ordering } : {}),
    },
  });

const USERS_QUERIES = {
  FETCH_USERS_SUPER_USER_PAGINATED: fetchUsersSuperUserPaginated,
  FETCH_IMPERSONATION_USERS: fetchImpersonationUsers,
};

export default USERS_QUERIES;
